// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  padding: 2rem;
  background-color: #f8f9fa;
}

.role-editor-card {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgb(0 0 0 / 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.role-editor-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 35px -10px rgb(0 0 0 / 0.15);
}

mat-card-header {
  padding: 1.5rem 1.5rem 0;
  border-bottom: 1px solid #e5e7eb;
}

mat-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.5rem;
}

.error-text {
  color: #dc2626;
  font-size: 0.875rem;
}

mat-card-content {
  padding: 1.5rem;
}

.permissions-container {
  margin-top: 2rem;
}

.permissions-container h3 {
  font-size: 1.25rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 1rem;
}

mat-form-field {
  width: 100%;
}

mat-selection-list {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.5rem;
}

mat-list-option {
  border-radius: 6px;
  margin: 4px 0;
  transition: background-color 0.2s ease;
}

mat-list-option:hover {
  background-color: #f3f4f6;
}

.permission-label {
  font-weight: 500;
  color: #1f2937;
}

.permission-description {
  color: #6b7280;
  font-size: 0.875rem;
}

mat-card-actions {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  gap: 1rem;
}

button[mat-raised-button] {
  min-width: 120px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

button[mat-raised-button][color="primary"] {
  background-color: #2563eb;
  transition: background-color 0.2s ease;
}

button[mat-raised-button][color="primary"]:hover {
  background-color: #1d4ed8;
}

button[mat-raised-button][color="warn"] {
  background-color: #dc2626;
  transition: background-color 0.2s ease;
}

button[mat-raised-button][color="warn"]:hover {
  background-color: #b91c1c;
}

button[disabled] {
  opacity: 0.7;
  cursor: not-allowed;
}
.warning-text {
  color: #f59e0b;
  font-size: 0.875rem;
}

.role-editor-card.read-only {
  opacity: 0.9;
}

.role-editor-card.read-only .mat-form-field {
  pointer-events: none;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  :host {
    padding: 1rem;
  }

  .role-editor-card {
    border-radius: 12px;
  }

  mat-card-header {
    padding: 1rem 1rem 0;
  }

  mat-card-content {
    padding: 1rem;
  }

  mat-card-actions {
    padding: 1rem;
    flex-direction: column;
  }

  button[mat-raised-button] {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/roleComponents/role-editor/role-editor.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;AACA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;AACA,gpKAAgpK","sourcesContent":[":host {\n  display: block;\n  padding: 2rem;\n  background-color: #f8f9fa;\n}\n\n.role-editor-card {\n  max-width: 900px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px -5px rgb(0 0 0 / 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.role-editor-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 20px 35px -10px rgb(0 0 0 / 0.15);\n}\n\nmat-card-header {\n  padding: 1.5rem 1.5rem 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\nmat-card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 0.5rem;\n}\n\n.error-text {\n  color: #dc2626;\n  font-size: 0.875rem;\n}\n\nmat-card-content {\n  padding: 1.5rem;\n}\n\n.permissions-container {\n  margin-top: 2rem;\n}\n\n.permissions-container h3 {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 1rem;\n}\n\nmat-form-field {\n  width: 100%;\n}\n\nmat-selection-list {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0.5rem;\n}\n\nmat-list-option {\n  border-radius: 6px;\n  margin: 4px 0;\n  transition: background-color 0.2s ease;\n}\n\nmat-list-option:hover {\n  background-color: #f3f4f6;\n}\n\n.permission-label {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.permission-description {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\nmat-card-actions {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n  gap: 1rem;\n}\n\nbutton[mat-raised-button] {\n  min-width: 120px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\nbutton[mat-raised-button][color=\"primary\"] {\n  background-color: #2563eb;\n  transition: background-color 0.2s ease;\n}\n\nbutton[mat-raised-button][color=\"primary\"]:hover {\n  background-color: #1d4ed8;\n}\n\nbutton[mat-raised-button][color=\"warn\"] {\n  background-color: #dc2626;\n  transition: background-color 0.2s ease;\n}\n\nbutton[mat-raised-button][color=\"warn\"]:hover {\n  background-color: #b91c1c;\n}\n\nbutton[disabled] {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.warning-text {\n  color: #f59e0b;\n  font-size: 0.875rem;\n}\n\n.role-editor-card.read-only {\n  opacity: 0.9;\n}\n\n.role-editor-card.read-only .mat-form-field {\n  pointer-events: none;\n}\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  :host {\n    padding: 1rem;\n  }\n\n  .role-editor-card {\n    border-radius: 12px;\n  }\n\n  mat-card-header {\n    padding: 1rem 1rem 0;\n  }\n\n  mat-card-content {\n    padding: 1rem;\n  }\n\n  mat-card-actions {\n    padding: 1rem;\n    flex-direction: column;\n  }\n\n  button[mat-raised-button] {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
